import Chip from '@mui/material/Chip';
import { LABEL_PRINT_STATUS_LABEL_HU, type LabelPrintStatus } from '@persped/shared';

/**
 * A nyomtatási státusz ADAT, nem hiba.
 *
 * A `FAILED`/`UNCONFIRMED` is `201`-gyel érkezik, mert a foglalás sikerült —
 * csak a nyomtatás kimenetele bizonytalan vagy rossz. Ezért státuszjelölő,
 * nem hibatoast: a sorszámok élnek, a javítás az újraküldés.
 *
 * A `UNCONFIRMED` szándékosan „warning" és nem „error": nem tudjuk, hogy
 * kijött-e a papír. Ha hibaként mutatnánk, az a felhasználót selejtezésre
 * ösztönözné — pont arra, amit a B9 tiltja, mert az égetné a fizikai
 * címkéket.
 */
const SZIN: Record<LabelPrintStatus, 'default' | 'info' | 'success' | 'warning' | 'error'> = {
  PENDING: 'info',
  SENT: 'info',
  UNCONFIRMED: 'warning',
  FAILED: 'error',
  CONFIRMED: 'success',
  NOT_PRINTED: 'default',
};

export function PrintStatusChip({ status }: { status: LabelPrintStatus }) {
  return (
    <Chip size="small" color={SZIN[status]} label={LABEL_PRINT_STATUS_LABEL_HU[status]} variant="outlined" />
  );
}
